<template>
  <v-toolbar :dark="dark" :color="computedColor" rounded="0" elevation="0" class="flex-grow-0">
    <template v-if="showBackButton">
      <Button icon aria-label="Back" @click="$emit('back')" class="mr-1">
        <Icon large icon="mdi-chevron-left" color="white" />
      </Button>
    </template>
    <div class="d-flex align-center" style="gap: 16px">
      <Icon v-if="icon" :icon="icon" :color="dark ? 'white' : 'black'" />
      <Typography variant="h-5">{{ title }}</Typography>
    </div>
    <v-spacer></v-spacer>
    <v-toolbar-items v-if="showCloseButton">
      <Button icon aria-label="Close" @click="$emit('close')">
        <Icon large :color="dark ? 'white' : 'black'" icon="mdi-close" />
      </Button>
    </v-toolbar-items>
  </v-toolbar>
</template>

<script>
import Typography from "@/components/generic/Typography.vue";
import Icon from "@/components/generic/Icon.vue";
import Button from "@/components/generic/Button.vue";

export default {
  name: "DrawerToolbar",
  components: {
    Typography,
    Icon,
    Button,
  },
  props: {
    title: {
      type: String,
      default: "",
    },
    admin: {
      type: Boolean,
      default: false,
    },
    showCloseButton: {
      type: Boolean,
      default: true,
    },
    showBackButton: {
      type: Boolean,
      default: false,
    },
    color: {
      type: String,
      default: "",
    },
    icon: {
      type: String,
      default: null,
    },
  },
  computed: {
    computedColor() {
      return this.color || (this.admin ? "systemPrimary" : "brandPrimary");
    },
    dark() {
      // Warning (yellow) preview banners need dark text/icons on the light background
      return this.computedColor !== "warning";
    },
  },
};
</script>
